import React, {HTMLAttributes} from 'react'

export const Panel: React.FC<HTMLAttributes<HTMLElement>> = ({children, className, ...props}) => (
  <div className={`${className} bg-white shadow sm:rounded-lg`} {...props}>
    <div className="px-4 py-5 sm:p-6">{children}</div>
  </div>
)
